<template>
  <div>
    <hr />
    <b-form inline @submit="performAction">
      <label class="mr-sm-2 font-weight-bolder mb-3 d-block">
        <i class="fa fa-list mr-2" aria-hidden="true"></i>
        {{ $t("Ações e Ações de Exportação") }}
      </label>

      <b-form-select
        name="status"
        v-model="action"
        :value="null"
        class="actions-input"
        @input="optionStatusEntregue(action)"
      >
        <option slot="first" :value="null" disabled>
          {{ $t("Seleciona o status...") }}
        </option>

        <optgroup :label="$t('Exportação')">
          <option value="exportAllOrders">
            {{ $t("Exportar todos os pedidos") }}
          </option>
          <option value="exportAllOrdersFiltered">
            {{ $t("Exportar pedidos filtrados") }}
          </option>
          <option value="exportAllOrdersSelected">
            {{ $t("Exportar pedidos selecionados") }}
          </option>
          <option value="exportModel">
            {{ $t("Exportar modelo de planilha para entrega") }}
          </option>
        </optgroup>

        <optgroup :label="$t('Etiquetas')">
          <!-- invoiced  waiting_expedition Pronto para embalar -->
          <option
            value="action_print_all"
            v-if="
              filters.status == 'invoiced' &&
              filters.sub_status == 'waiting_expedition'
            "
          >
            {{ $t("Imprimir tudo") }}
          </option>
          <option
            value="action_print_gnre"
            v-if="
              filters.status == 'invoiced' &&
              filters.sub_status == 'waiting_expedition'
            "
          >
            {{ $t("Imprimir GNRE") }}
          </option>
          <option value="action_print_header_pdf">
            {{ $t("Imprimir Cabeçalhos") }}
          </option>
          <option value="action_print_labels">
            {{ $t("Imprimir etiquetas") }}
          </option>
          <option value="action_create_plp">
            {{ $t("Gerar PLP") }}
          </option>
        </optgroup>

        <optgroup :label="$t('Status')">
          <!-- Pendentes de separação -->
          <option
            value="action_processing_picking"
            v-if="filters.status == 'approved'"
          >
            {{ $t("Imprimir Lista de Picking") }}
          </option>

          <!-- Em separação -->
          <option
            value="action_sigep"
            v-if="
              filters.status == 'picking' &&
              filters.sub_status == 'processing_picking'
            "
          >
            {{ $t("Enviar por SIGEP WEB") }}
          </option>
          <option
            value="action_pending_invoice"
            v-if="
              filters.status == 'picking' &&
              filters.sub_status == 'processing_picking'
            "
          >
            {{ $t("Marcar como Separado") }}
          </option>

          <!-- Separados -->
          <option
            value="action_waiting_invoice"
            v-if="
              filters.status == 'picking' &&
              filters.sub_status == 'pending_invoice'
            "
          >
            {{ $t("Gerar nota fiscal") }}
          </option>

          <option
            value="action_print_nfe"
            v-if="
              filters.status == 'invoiced' &&
              filters.sub_status == 'waiting_expedition'
            "
          >
            {{ $t("Baixar PDF notas fiscais") }}
          </option>
          <option
            value="action_print_xlsx_nfe"
            v-if="
              filters.status == 'invoiced' &&
              filters.sub_status == 'waiting_expedition'
            "
          >
            {{ $t("Baixar XLSX das notas fiscais") }}
          </option>

          <option
            value="action_processing_expedition"
            v-if="
              filters.status == 'invoiced' &&
              filters.sub_status == 'waiting_expedition'
            "
          >
            {{ $t("Marcar como embalado") }}
          </option>

          <!-- -->
          <option
            value="action_dispatched"
            v-if="
              filters.status == 'invoiced' &&
              filters.sub_status == 'processing_expedition'
            "
          >
            {{ $t("Marcar como enviado") }}
          </option>

          <option
            value="delivered"
            v-if="filters.status && filters.status == 'shipped'"
          >
            {{ $t("Alterar status para Disponível para retirada") }}
          </option>

          <option value="picking">
            {{ $t("Alterar status para Disponível para retirada") }}
          </option>

          <option value="delivered">
            {{ $t("Alterar status para entregue (status final)") }}
          </option>

          <option value="canceled">
            {{ $t("Alterar status para cancelado (status final)") }}
          </option>
        </optgroup>

        <optgroup :label="$t('Notificações')">
          <option value="resendnotifications">
            {{ $t("Reenviar notificações") }}
          </option>
        </optgroup>
      </b-form-select>
      <p class="text-right">
        <b-button
          type="submit"
          variant="info"
          ref="submitButton"
          class="w-100"
          size="sm"
        >
          {{ $t("Executar") }}
          <i class="fa fa-play ml-2"></i>
        </b-button>
      </p>
    </b-form>
    <hr />

    <form class="import-file">
      <label for="file" class="mr-sm-2 font-weight-bolder mb-3 d-block">
        <i class="fa fa-upload mr-2"></i>
        {{ $t("Importar planilha") }} e {{ $t("Entregas em massa") }}
      </label>
      <div class="input-group">
        <div class="custom-file">
          <input
            accept=".xls, .csv, .xlsx"
            v-on:change="setFile()"
            ref="file"
            type="file"
            class="custom-file-input"
            id="inputGroupFile01"
          />
          <label class="custom-file-label" for="inputGroupFile01">
            {{ fileName }}
          </label>
        </div>
      </div>
      <div class="text-center">
        <p class="text-right">
          <b-button
            type="submit"
            variant="info"
            @click="importOrders"
            :disabled="!file"
            class="w-100"
            size="sm"
          >
            {{ $t("Importar") }}
            <i class="fa fa-play ml-2"></i>
          </b-button>
        </p>
      </div>
    </form>

    <!-- Modal Component - impressão de documentos -->
    <b-modal
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      :title="$t('Impressão de documentos')"
      ref="modalPrintAll"
      @ok="handleOkPrint"
      :okDisabled="isValidEmail() ? false : true"
    >
      <b-form>
        <p>
          {{
            $t(
              "Suas nostas fiscais e GNREs serão exportadas para um arquivo PDF e este arquivo será enviado para você assim que este processo estiver concluído."
            )
          }}
        </p>

        <hr />

        <!-- <p>
          <label for="email">Email:</label>
          <b-form-input
            name="email"
            type="email"
            :placeholder="$t('meu@email.com.br')"
            v-model="email"
          ></b-form-input>
        </p> -->
      </b-form>
    </b-modal>

    <!-- Modal Component - exportação de pedidos -->
    <b-modal
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      :title="$t('Exportação de pedidos')"
      ref="modalExportOrders"
      @ok="handleOk"
    >
      <b-form>
        <p>
          {{
            $t(
              "Todos os seus pedidos serão exportados para um arquivo no formato escolhido e este arquivo será enviado para você assim que este processo estiver concluído."
            )
          }}
        </p>

        <hr />

        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="customRadioSelected1"
            name="customRadioSelected"
            class="custom-control-input"
            checked
            v-model="exportSelected"
            value="csv"
          />
          <label class="custom-control-label" for="customRadioSelected1">{{
            $t("Exportar como XLSX")
          }}</label>
        </div>
        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="customRadioSelected2"
            name="customRadioSelected"
            class="custom-control-input"
            v-model="exportSelected"
            value="pdf"
          />
          <label class="custom-control-label" for="customRadioSelected2">{{
            $t("Exportar como PDF")
          }}</label>
        </div>

        <div v-if="exportSelected === 'pdf'">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="checkbox"
              name="compactPdfCheckbox"
              id="compactPdfCheckbox1"
              v-model="compactPdf"
              :true-value="true"
              :false-value="false"
            />
            <label class="form-check-label" for="compactPdfCheckbox1"
              >Versão compacta</label
            >
          </div>
        </div>

        <!-- <p>
          <label for="email">Email:</label>
          <b-form-input
            name="email"
            type="email"
            :placeholder="$t('meu@email.com.br')"
            v-model="email"
          ></b-form-input>
        </p> -->
      </b-form>
    </b-modal>

    <b-modal
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      :title="$t('Exportação de pedidos')"
      ref="modalExportOrdersSelected"
      @ok="exportSelecionados"
    >
      <b-form>
        <p>{{ $t("Qual formato deseja exportar os pedidos selecionados?") }}</p>

        <hr />

        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="customRadio1"
            name="customRadio"
            class="custom-control-input"
            checked
            v-model="exportSelected2"
            value="csv"
          />
          <label class="custom-control-label" for="customRadio1">{{
            $t("Exportar como XLSX")
          }}</label>
        </div>
        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="customRadio2"
            name="customRadio"
            class="custom-control-input"
            v-model="exportSelected2"
            value="pdf"
          />
          <label class="custom-control-label" for="customRadio2">{{
            $t("Exportar como PDF")
          }}</label>
        </div>

        <div v-if="exportSelected2 === 'pdf'">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="checkbox"
              name="compactPdfCheckbox"
              id="compactPdfCheckbox"
              v-model="compactPdf"
              :true-value="true"
              :false-value="false"
            />
            <label class="form-check-label" for="compactPdfCheckbox"
              >Versão compacta</label
            >
          </div>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import swal from "sweetalert2";
import axios from "axios";
import _ from "lodash";
import barramento from "../../barramento";

export default {
  //props: ['items', 'value'],
  props: ["items", "value", "applyFilter", "loadTotalOrders", "filters"],

  data() {
    return {
      action: null,
      only_filtered: false,
      exportSelected: "csv",
      exportSelected2: "csv",
      email: null,
      file: null,
      type: "all",
      fileName: "Selecione",
      compactPdf: false,
    };
  },

  computed: {
    ...mapGetters({
      user: "getUserObject",
      idsOnActionList: "getActionList",
    }),
    hasPermissionToExport() {
      const subuser = this.user.pluggToSubuser;
      const permissions = subuser ? subuser.permissions : null;

      const has = !(
        subuser &&
        permissions &&
        !permissions.find((x) => x === "core.exportOrders")
      );
      return has;
    },
  },

  watch: {
    //   'file'(newVal) {
    //       if (newVal) {
    //           return true;
    //       } else {
    //           return false;
    //       }
    //   }
  },

  methods: {
    ...mapActions({
      cleanActionList: "cleanActionList",
    }),

    exportErrorAlert() {
      swal({
        title: "Ops!",
        text: this.$t("Você não possui permissão para exportar pedidos."),
        type: "error",
        closeOnConfirm: false,
        closeOnCancel: false,
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: true,
      });
    },

    setFile() {
      if (
        this.$refs &&
        this.$refs.file &&
        this.$refs.file.files &&
        this.$refs.file.files[0]
      ) {
        this.file = this.$refs.file.files[0];
        this.fileName = `${this.file.name.substr(0, 7)}...`;
      }
    },
    optionStatusEntregue() {
      barramento.$emit("orders_action_status", this.action === "delivered");
    },
    performAction(event) {

      event.preventDefault();
      let button = event.target.querySelector("button");
      this.$root.botao = button;
      var self = this;

      switch (this.action) {
        case "action_processing_picking":
          if (this.idsOnActionList == "") {
            swal({
              title: "Ops!",
              text: this.$t(
                "Nenhum pedido selecionado. Por favor, selecione ao menos um pedido realizar esta ação"
              ),
            });
            return false;
          }
          this.changeStatus("picking", "processing_picking", button, true);
          break;
        case "action_pending_invoice":
          /*if (this.idsOnActionList == "") {
            alert(
              self.$t(
                "Nenhum pedido selecionado. Por favor, selecione ao menos um pedido realizar esta ação"
              )
            );
            return false;
          }*/
          this.changeStatus("picking", "pending_invoice", button, true);
          break;
        case "action_waiting_invoice":
          /*if (this.idsOnActionList == "") {
            alert(
              self.$t(
                "Nenhum pedido selecionado. Por favor, selecione ao menos um pedido realizar esta ação"
              )
            );
            return false;
          }*/
          this.changeStatus("waiting_invoice", "waiting_invoice", button, true);
          break;
        case "action_print_all":
          //manda para a fila de impressão de todos os documentos
          this.type == "all";
          this.showPrintAllModal();
          break;
        case "action_print_nfe":
          this.print_nfes(button);
          break;
        case "action_print_xlsx_nfe":
          this.print_xlsx_nfes(button);
          break;
        case "action_print_gnre":
          //manda para a fila de impressão de GNREs
          this.print_gnres(button);
          break;
        case "action_print_labels":
          this.print_labels(button);
          break;
        case "action_create_plp":
          this.create_plp(button);
          break;
        case "action_processing_expedition":
          //marcado como embalado, mudar o status para 'invoiced', 'processing_expedition'
          this.changeStatus("invoiced", "processing_expedition", button, true);
          break;
        case "action_dispatched":
          //marcado como enviado, mudar o status para 'shipping_informed', 'dispatched'
          this.changeStatus("shipping_informed", "dispatched", button, true);
          break;
        //
        case "exportAllOrders":
          if (!this.hasPermissionToExport) {
            this.exportErrorAlert();
            return;
          }

          this.showExportOrderModal();
          break;
        case "exportAllOrdersFiltered":
          if (!this.hasPermissionToExport) {
            this.exportErrorAlert();
            return;
          }

          var filtrado = 0;
          for (var prop in this.value) {
            if (this.value[prop] !== null) {
              filtrado = 1;
            }
          }
          if (filtrado === 1) {
            this.showExportOrderModal();
          } else {
            alert(self.$t("Não há filtros. Use pelo menos um filtro"));
            return false;
          }
          break;
        case "exportAllOrdersSelected":
          if (!this.hasPermissionToExport) {
            this.exportErrorAlert();
            return;
          }

          if (this.idsOnActionList == "") {
            alert(
              self.$t(
                "Nenhum pedido selecionado. Por favor, selecione ao menos um pedido para exportar"
              )
            );
            return false;
          }
          this.showExportOrderSelectedModal();
          break;
        case "action_print_header_pdf":
          if (!this.hasPermissionToExport) {
            this.exportErrorAlert();
            return;
          }

          if (this.idsOnActionList == "") {
            swal({
              title: "Ops!",
              text: this.$t(
                "Nenhum pedido selecionado. Por favor, selecione ao menos um pedido realizar esta ação"
              ),
            });
            return false;
          }
          this.createHeaderPDF(button);
          break;
        case "exportModel":
          if (!this.hasPermissionToExport) {
            this.exportErrorAlert();
            return;
          }

          this.exportModel(button);
          break;
        case "delivered":
          this.changeStatus("delivered", null, button, true);
          break;
        case "picking":
          this.changeStatus("picking", "pending_invoice", button, true);
          break;
        case "canceled":
          this.changeStatus("canceled", null, button, true);
          break;
        case "action_sigep":
          this.sigep(button, true);
          break;
        case "resendnotifications":
          this.resendNotifications(button);
          break;
      }
    },

    print_nfes(button) {
      this.toggleLoadingButton(button);

      var ids = [];
      var i;
      var sel_itens = this.idsOnActionList.length;
      var q;

      this.type == "nfe";

      if (sel_itens <= 20) {
        for (i = 0; i < sel_itens; i++) {
          q = _.find(this.items, { id: this.idsOnActionList[i] });

          if (q) {
            ids.push({
              id: this.idsOnActionList[i],
              shipments: q.shipments,
            });
          }
        }

        axios
          .post("/api/documents/get_nfes", ids)
          .then((response) => {
            if (response.data.erro) {
              swal({
                title: "Ops!",
                text: this.$t(response.data.erro),
                type: "error",
              });
            } else {
              let link = document.createElement("a");
              link.setAttribute("href", response.data.file);
              link.setAttribute("download", response.data.file);
              link.setAttribute("target", "_blank");
              link.style.display = "none";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              swal({
                title: this.$t("Pronto!"),
                text: this.$t("Notas fiscais geradas com sucesso!"),
                type: "success",
              });
            }
            this.applyFilter();
            this.toggleLoadingButton(button);
          })
          .catch((error) => {
            swal({
              title: "Ops!",
              text: this.$t(response.data.erro),
              type: "error",
            });
            this.toggleLoadingButton(button);
          });
      } else {
        swal({
          title: this.$t("Ops!"),
          text: this.$t(
            "Você selecionou " +
              sel_itens +
              " pedidos. Por favor, selecione até 20."
          ),
          type: "error",
        });
      }
    },

    print_xlsx_nfes(button) {
      this.toggleLoadingButton(button);

      var ids = [];
      var i;
      var sel_itens = this.idsOnActionList.length;
      var q;

      this.type == "nfe";

      for (i = 0; i < sel_itens; i++) {
        q = _.find(this.items, { id: this.idsOnActionList[i] });

        if (q) {
          ids.push({
            id: this.idsOnActionList[i],
            shipments: q.shipments,
          });
        }
      }

      axios
        .post("/api/orders/export/nf", ids)
        .then((response) => {
          if (response.data.erro) {
            swal({
              title: "Ops!",
              text: this.$t(
                "Ocorreu algum problema ao tentar gerar as notas fiscais, tente novamente em alguns instantes."
              ),
              type: "error",
            });
          } else {
            let link = document.createElement("a");
            link.setAttribute("href", response.data.file);
            link.setAttribute("download", response.data.file);
            link.setAttribute("target", "_blank");
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            swal({
              title: this.$t("Pronto!"),
              text: this.$t("Notas fiscais geradas com sucesso!"),
              type: "success",
            });
          }
          this.applyFilter();
          this.toggleLoadingButton(button);
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t(response.data.erro),
            type: "error",
          });
          this.toggleLoadingButton(button);
        });
    },

    print_gnres(button) {
      this.toggleLoadingButton(button);

      var ids = [];
      var i;
      var sel_itens = this.idsOnActionList.length;
      var q;

      this.type == "nfe";

      if (sel_itens > 0) {
        if (sel_itens == this.items.length) {
          this.toggleLoadingButton(button);
          this.showPrintAllModal();
        } else {
          for (i = 0; i < sel_itens; i++) {
            q = _.find(this.items, { id: this.idsOnActionList[i] });

            if (q) {
              ids.push({
                id: this.idsOnActionList[i],
                shipments: q.shipments,
              });
            }
          }

          axios
            .post("/api/documents/get_gnres", ids)
            .then((response) => {
              if (response.data.erro) {
                swal({
                  title: "Ops!",
                  text: this.$t(response.data.erro),
                  type: "error",
                });
              } else {
                let link = document.createElement("a");
                link.setAttribute("href", response.data.file);
                link.setAttribute("download", response.data.file);
                link.setAttribute("target", "_blank");
                link.style.display = "none";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                swal({
                  title: this.$t("Pronto!"),
                  text: this.$t("GNREs geradas com sucesso!"),
                  type: "success",
                });
              }
              this.applyFilter();
              this.toggleLoadingButton(button);
            })
            .catch((error) => {
              swal({
                title: "Ops!",
                text: this.$t(
                  "Ocorreu algum problema ao tentar gerar as GNREs, tente novamente em alguns instantes."
                ),
                type: "error",
              });
              this.toggleLoadingButton(button);
            });
        }
      } else {
        //todos os itens
        this.toggleLoadingButton(button);
        this.showPrintAllModal();
      }
    },

    print_labels(button) {
      this.toggleLoadingButton(button);

      var ids = [];
      var i;

      if (this.idsOnActionList.length > 0) {
        //itens selecionados
        ids = this.idsOnActionList;
      } else {
        //todos os itens
        for (i = 0; i < this.items.length; i++) {
          ids.push(this.items[i].id);
        }
      }

      axios
        .post("/api/documents/get_labels", ids)
        .then((response) => {
          if (response.data.urls) {
            response.data.urls.forEach(function (pdf_link) {
              if (pdf_link != null) {
                var type = pdf_link.substr(pdf_link.length - 3);
                let link = document.createElement("a");
                link.setAttribute("href", pdf_link);
                link.setAttribute("target", "_blank");
                if (type == "zpl") {
                  link.setAttribute("download", "etiqueta.zpl");
                  link.href = window.URL.createObjectURL(
                    new Blob([pdf_link], { type })
                  );
                } else {
                  link.setAttribute("download", pdf_link);
                }

                link.style.display = "none";
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
              }
            });
            swal({
              title: this.$t("Pronto!"),
              text: this.$t("Etiquetas geradas com sucesso!"),
              type: "success",
            });
            this.applyFilter();
          } else {
            if (response.data.error) {
              if (response.data.error.orders) {
                var text = this.$t(
                  "Ocorreu algum problema ao tentar gerar as etiquetas do(s) pedido(s)"
                );

                for (var key in response.data.error.orders) {
                  text = text + "<br><br>" + this.$t("Pedido") + " " + key;
                  for (var key2 in response.data.error.orders[key]) {
                    text =
                      text + "<br>" + response.data.error.orders[key][key2];
                  }
                }
              }
              if (response.data.error.config) {
                var text = this.$t(
                  "Ocorreu algum problema ao tentar gerar as etiquetas"
                );

                text =
                  text +
                  "<br><br>" +
                  this.$t("Clique") +
                  ' <a href="http://beta.plugg.to/settings#labels" target="_parent">' +
                  this.$t("aqui") +
                  " <a> " +
                  this.$t("para configurar o formato de impressão") +
                  ".";
              }

              swal({
                title: "Ops!",
                html: text,
                type: "error",
              });
            } else {
              swal({
                title: this.$t("Pronto!"),
                text: this.$t("Etiquetas geradas com sucesso!"),
                type: "success",
              });
            }
          }
          this.toggleLoadingButton(button);
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t(error.response.data),
            type: "error",
          });
          this.toggleLoadingButton(button);
        });
    },

    create_plp(button) {
      this.toggleLoadingButton(button);

      let ids = [];
      let i;

      ids = this.idsOnActionList.length > 0 ? this.idsOnActionList : [];

      axios
        .post("/api/documents/create_plp", { pluggto_order_ids: ids })
        .then((response) => {
          this.downloadFile(
            response.data.url,
            `plp_${response.data.sigep_plp_id}.pdf`
          );
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t(error.response.data),
            type: "error",
          });
        })
        .finally(() => {
          this.toggleLoadingButton(button);
        });
    },

    createHeaderPDF(button) {
      this.toggleLoadingButton(button);

      var tz = new Date().getTimezoneOffset();
      let data = {
        filtered: false,
        type: "pdfHeader",
        tzUTC: tz,
        ids: [],
      };

      data.ids = this.idsOnActionList.length > 0 ? this.idsOnActionList : [];

      axios
        .post("/api/orders/export/selecionados", data)
        .then((success) => {
          /*let link = document.createElement("a");
          link.setAttribute("href", success.data.file);
          link.setAttribute("download", success.data.file);
          link.setAttribute("target", "_blank");
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);*/
          swal({
            title: this.$t("Pronto!"),
            text: this.$t("Cabeçalho dos Pedidos exportados com sucesso!"),
            type: "success",
          });
          this.toggleLoadingButton(this.$root.botao);
          this.cleanActionList();
          this.loadTotalOrders();
          this.applyFilter();
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t(
              "Não foi possivel realizar a exportação do pedido, tente novamente em alguns instantes."
            ),
          });
          this.toggleLoadingButton(this.$root.botao);
        });
    },

    downloadFile(url, fileName) {
      // Create an invisible A element
      const a = document.createElement("a");
      a.style.display = "none";
      document.body.appendChild(a);

      // Set the HREF to a Blob representation of the data to be downloaded
      a.href = url;

      // Use download attribute to set set desired file name
      a.setAttribute("download", fileName);

      // Trigger the download by simulating click
      a.click();

      // Cleanup
      window.URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
    },

    showExportOrderModal() {
      this.$refs.modalExportOrders.show();
    },

    showExportOrderSelectedModal() {
      this.$refs.modalExportOrdersSelected.show();
    },

    showPrintAllModal() {
      this.$refs.modalPrintAll.show();
    },

    exportSelecionados(event) {
      this.toggleLoadingButton(this.$root.botao);
      var tz = new Date().getTimezoneOffset();
      let data = {
        filtered: false,
        type: this.exportSelected2,
        tzUTC: tz,
        ids: [],
      };

      if (this.exportSelected2 === "pdf") {
        data.compactPdf = this.compactPdf;
      }

      data.ids = this.idsOnActionList;

      axios
        .post("/api/orders/export/selecionados", data)
        .then((success) => {
          /*let link = document.createElement("a");
          link.setAttribute("href", success.data.file);
          link.setAttribute("download", success.data.file);
          link.setAttribute("target", "_blank");
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);*/
          swal({
            title: this.$t("Pronto!"),
            text: this.$t("Agendamento de exportação criado com sucesso, acompanhe o seu e-mail!"),
            type: "success",
          });
          this.toggleLoadingButton(this.$root.botao);
          this.cleanActionList();
          this.loadTotalOrders();
          this.applyFilter();
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t(
              "Não foi possivel realizar a exportação do pedido, tente novamente em alguns instantes."
            ),
          });
          this.toggleLoadingButton(this.$root.botao);
        });
    },

    exportModel(button) {
      this.toggleLoadingButton(button);
      let data = {
        orders: [],
      };

      this.idsOnActionList.forEach((id) => {
        this.items.forEach((item) => {
          if (item.id === id) {
            data.orders.push(item);
          }
        });
      });

      axios
        .post("/api/orders/export/shippingSheet", data)
        .then((success) => {
          let link = document.createElement("a");
          link.setAttribute("href", success.data.file);
          link.setAttribute("download", success.data.file);
          link.setAttribute("target", "_blank");
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.toggleLoadingButton(button);
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t(
              "Não foi possivel realizar a exportação do pedido, tente novamente em alguns instantes."
            ),
          });
          this.toggleLoadingButton(button);
        });
    },

    handleOk(event) {
      event.preventDefault();

      let data = {
        filters: this.value,
        email: this.email,
        type: this.exportSelected,
        ids: [],
      };

      if (this.exportSelected === "pdf") {
        data.compactPdf = this.compactPdf;
      }

      axios
        .post("/api/orders/export", data)
        .then((success) => {
          swal({
            title: this.$t("Pronto!"),
            text: this.$t(
              "Agendamento de exportação criado com sucesso, acompanhe o seu e-mail!"
            ),
            type: "success",
          });
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t("Não foi possivel exportar os pedidos."),
            type: "error",
          });
        });

      this.$refs.modalExportOrders.hide();
    },

    handleOkPrint(event) {
      event.preventDefault();

      let data = {
        email: this.email,
        type: this.type,
      };

      axios
        .post("/api/documents/get_all", data)
        .then((success) => {
          this.email = null;
          swal({
            title: this.$t("Pronto!"),
            text: this.$t(
              "Agendamento de exportação de documentos criado com sucesso, acompanhe o seu e-mail!"
            ),
            type: "success",
          });
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t("Não foi possivel exportar os documentos."),
            type: "error",
          });
        });

      this.type == "all";

      this.$refs.modalPrintAll.hide();
    },

    importOrders(event) {
      event.preventDefault();
      let btn = event.target.querySelector(".fa");
      btn.classList.toggle("fa-play");
      btn.classList.toggle("fa-spinner");

      let formData = new FormData();
      formData.append("sheet", this.file);

      axios
        .post("/api/orders/import", formData)
        .then((success) => {
          swal({
            title: this.$t("Pronto!"),
            text: this.$t(
              "Seu arquivo já foi incluido para importação, em breve você podera vê-lo em seu painel."
            ),
            type: "success",
          });
          btn.classList.toggle("fa-play");
          btn.classList.toggle("fa-spinner");
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t(
              "Não foi possivel processar seu arquivo, tente novamente em alguns instantes."
            ),
            type: "error",
          });
          btn.classList.toggle("fa-play");
          btn.classList.toggle("fa-spinner");
        });
    },

    changeStatus(status, sub_status, button, show_modal) {
      if (!this.idsOnActionList.length) {
        swal(
          "Ops!",
          this.$t("Você selecionou os pedidos para aplicar esta ação?")
        );
      } else {
        this.toggleLoadingButton(button);
        let ids = this.idsOnActionList.map((id) => {
          return { id: id, status: status, sub_status: sub_status };
        });

        this.$http
          .post("/api/orders/updatestatus", ids)
          .then((response) => {
            let ids = response.data.join(", ");
            if (response.data.length) {
              swal(
                "Ops",
                this.$t(
                  "Não foi possivel alterar o status dos pedidos com ID: ${ids}, tente novamente em alguns instantes."
                ),
                "warning"
              );
              //this.toggleLoadingButton(button);
              return;
            }
            if (show_modal == true) {
              swal(
                "Pronto!",
                this.$t("Os status dos pedidos foram alterados com sucesso!"),
                "success"
              );
            }

            this.toggleLoadingButton(button);
          })
          .catch((error) => {
            swal(
              "Ops!",
              this.$t(
                "Não foi possivel alterar o status dos pedidos com ID: ${ids}, tente novamente em alguns instantes."
              )
              //"warning"
            );
            this.toggleLoadingButton(button);
          });

        if (status == "picking" && sub_status == "processing_picking") {
          //this.$refs.modalExportOrdersSelected.show();
          this.exportPicking();
          this.toggleLoadingButton(button);
        } else {
          this.cleanActionList();
          this.loadTotalOrders();
          this.applyFilter();
        }
      }
    },

    exportPicking() {
      this.toggleLoadingButton(this.$root.botao);

      let data = {
        filtered: false,
        type: this.exportSelected2,
        ids: [],
      };

      data.ids = this.idsOnActionList;

      axios
        .post("/api/orders/export/picking", data)
        .then((success) => {
          let link = document.createElement("a");
          link.setAttribute("href", success.data.file);
          link.setAttribute("download", success.data.file);
          link.setAttribute("target", "_blank");
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          swal({
            title: this.$t("Pronto!"),
            text: this.$t("Lista de picking gerada com sucesso!"),
            type: "success",
          });
          this.toggleLoadingButton(this.$root.botao);
          this.cleanActionList();
          this.loadTotalOrders();
          this.applyFilter();
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t(
              "Não foi possivel gerar a lista de picking, tente novamente em alguns instantes."
            ),
          });
          this.toggleLoadingButton(this.$root.botao);
        });
    },

    sigep(button, show_modal) {
      if (!this.idsOnActionList.length) {
        swal(
          "Ops!",
          this.$t("Você selecionou os pedidos para aplicar esta ação?")
        );
      } else {
        this.toggleLoadingButton(button);
        let ids = this.idsOnActionList.map((id) => {
          return { id: id };
        });

        this.$http
          .post("/api/orders/sigep", ids)
          .then((response) => {
            let ids = response.data.join(", ");
            if (response.data.length) {
              swal(
                "Ops",
                this.$t(
                  "Não foi possivel alterar o método de envio, tente novamente em alguns instantes."
                ),
                "warning"
              );
              //this.toggleLoadingButton(button);
              return;
            }
            if (show_modal == true) {
              swal(
                "Pronto!",
                this.$t("Os pedidos foram alterados com sucesso!"),
                "success"
              );
            }

            this.toggleLoadingButton(button);
          })
          .catch((error) => {
            /*swal(
              "Ops!",
              this.$t(
                "Não foi possivel reenviar a notificação para os pedidos selecionados, tente novamente em alguns instantes."
              ),
              //"warning"
            );*/
            this.toggleLoadingButton(button);
          });

        this.cleanActionList();
        this.loadTotalOrders();
        this.applyFilter();
      }
    },

    resendNotifications(button) {
      if (!this.idsOnActionList.length) {
        swal(
          "Ops",
          this.$t("Você selecionou os pedidos para aplicar esta ação?")
        );
        return;
      }

      this.toggleLoadingButton(button);
      this.$http
        .post("/api/orders/notification/resend", this.idsOnActionList)
        .then((response) => {
          //if (response.data.length) {
          if (response.data) {
            let ids = response.data.join(", ");
            if (ids.length != 0) {
              swal(
                "Ops",
                this.$t(
                  "Não foi possivel reenviar as notificações dos pedidos selecionados, tente novamente em alguns instantes."
                ),
                "warning"
              );
              this.toggleLoadingButton(button);
              return;
            }

            swal(
              this.$t("Pronto!"),
              this.$t("O reenvio da notificação foi enviado com sucesso!"),
              "success"
            );
            this.toggleLoadingButton(button);
          }
        })
        .catch((error) => {
          swal(
            "Ops!",
            this.$t(
              "Não foi possivel reenviar a notificação para os pedidos selecionados, tente novamente em alguns instantes."
            ),
            "warning"
          );
          this.toggleLoadingButton(button);
        });

      this.cleanActionList();
    },

    isValidEmail() {
      var regex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return regex.test(String(this.email).toLowerCase());
    },

    toggleLoadingButton(btn = null) {
      // let btn = this.$refs.submitButton;
      let icon = btn.querySelector("i");
      icon.classList.toggle("fa-play");
      icon.classList.toggle("fa-spinner");

      if (icon.classList.contains("fa-spinner")) {
        btn.setAttribute("disabled", true);
      } else {
        btn.removeAttribute("disabled");
      }
    },
  },
};
</script>

<style>
button {
  margin-top: 1rem;
}

.import-file {
  margin: 1rem 0;
}

.fa-spinner {
  animation: spin 1s linear infinite;
}

.actions-input {
  width: 100% !important;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/components/Orders/OrdersAction.vue